// Bloc « Ma carte de fidélité » du tableau de bord : nom, récompense, couleur, logo, photo
import { useState } from 'react'
import { supabase } from './supabase'
import { CORAL, CHARBON } from './actions'
import { recadrer, logoInitiales, envoyerImage } from './images'

const COULEURS = ['#1C1C1C', '#E8522A', '#B23A48', '#7A2E8E', '#2F4B8C', '#1F7A8C', '#2E6B4E', '#8C6A2F']

const champ = { width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #e8e0d8', fontSize: 14, boxSizing: 'border-box', marginTop: 4 }
const label = { display: 'block', fontSize: 12, color: '#888', marginBottom: 10 }

// Aperçu fidèle de la carte telle que Google Wallet l'affiche
function ApercuCarte({ nom, objectif, recompense, couleur, logo, banniere }) {
  return (
    <div style={{ background: couleur, borderRadius: 14, color: '#fff', overflow: 'hidden', marginBottom: 14 }}>
      <div style={{ padding: '12px 14px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {logo
            ? <img src={logo} alt="" style={{ width: 26, height: 26, borderRadius: '50%', objectFit: 'cover', background: '#fff' }} />
            : <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>{(nom || 'J')[0]?.toUpperCase()}</div>}
          <span style={{ fontSize: 13 }}>{nom || 'Mon commerce'}</span>
        </div>
        <div style={{ fontSize: 16, fontWeight: 600, margin: '10px 0' }}>{objectif} passages = {recompense || 'Récompense'}</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, opacity: 0.75 }}><span>Nom</span><span>Tampons</span></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}><span>Élodie</span><span>4/{objectif}</span></div>
      </div>
      {banniere && <img src={banniere} alt="" style={{ width: '100%', aspectRatio: '1032 / 336', objectFit: 'cover', display: 'block' }} />}
    </div>
  )
}

export default function ReglagesCarte({ commerce, session, onEnregistre, onErreur, demo = false }) {
  const objectif = commerce?.objectif_tampons || 10
  const [brouillon, setBrouillon] = useState(null)
  const [enCours, setEnCours] = useState(false)
  const [ok, setOk] = useState(false)

  function ouvrir() {
    setBrouillon({
      nom: commerce?.nom || '',
      recompense: commerce?.recompense || '',
      objectif_tampons: objectif,
      couleur: commerce?.couleur || '#1C1C1C',
      logoFichier: null, logoApercu: commerce?.logo_url || null,
      banniereFichier: null, banniereApercu: commerce?.banniere_url || null,
    })
  }

  function choisirImage(e, cle) {
    const fichier = e.target.files?.[0]
    if (!fichier) return
    if (!/^image\/(png|jpeg)$/.test(fichier.type)) { onErreur('Image : formats acceptés PNG ou JPG.'); return }
    if (fichier.size > 8 * 1024 * 1024) { onErreur('Image trop lourde (8 Mo maximum).'); return }
    setBrouillon(b => ({ ...b, [`${cle}Fichier`]: fichier, [`${cle}Apercu`]: URL.createObjectURL(fichier) }))
  }

  async function enregistrer() {
    const b = brouillon
    const objectifSaisi = parseInt(b.objectif_tampons, 10)
    if (!b.nom.trim() || !b.recompense.trim() || !(objectifSaisi >= 3 && objectifSaisi <= 30)) {
      onErreur('Réglages : nom et récompense obligatoires, entre 3 et 30 tampons.')
      return
    }
    if (demo) {
      // Démo : rien n'est envoyé, on applique juste l'aperçu
      onEnregistre({ ...commerce, nom: b.nom.trim(), recompense: b.recompense.trim(), objectif_tampons: objectifSaisi,
        couleur: b.couleur, logo_url: b.logoApercu, banniere_url: b.banniereApercu })
      setBrouillon(null)
      return
    }
    setEnCours(true)
    try {
      const uid = session.user.id
      const maj = { nom: b.nom.trim(), recompense: b.recompense.trim(), objectif_tampons: objectifSaisi, couleur: b.couleur }

      if (b.logoFichier) {
        maj.logo_url = await envoyerImage(uid, 'logo', await recadrer(b.logoFichier, 660, 660))
      } else if (!commerce?.logo_url || commerce.logo_url.includes('/logo-auto-')) {
        // Pas de logo envoyé : on (re)génère les initiales avec la couleur choisie
        maj.logo_url = await envoyerImage(uid, 'logo-auto', await logoInitiales(maj.nom, b.couleur))
      }
      if (b.banniereFichier) {
        maj.banniere_url = await envoyerImage(uid, 'banniere', await recadrer(b.banniereFichier, 1032, 336, 'image/jpeg'))
      } else if (!b.banniereApercu) {
        maj.banniere_url = null
      }

      const { data, error } = await supabase.from('commerces').update(maj).eq('id', uid).select().single()
      if (error) throw error

      // Applique le nouveau look à toutes les cartes déjà dans les téléphones
      const { data: res, error: errWallet } = await supabase.functions.invoke('generate-wallet-card', { body: { action: 'classe' } })
      if (errWallet || res?.error) {
        console.error(errWallet || res.error)
        onErreur('Réglages enregistrés, mais la mise à jour des cartes Google a échoué. Réessaie dans un instant.')
      }

      onEnregistre(data)
      setBrouillon(null)
      setOk(true)
      setTimeout(() => setOk(false), 2500)
    } catch (err) {
      console.error(err)
      onErreur("Impossible d'enregistrer les réglages.")
    }
    setEnCours(false)
  }

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: '1.25rem', border: '1px solid #e8e0d8' }}>
      <div style={{ fontSize: 12, color: '#999', fontWeight: 500, marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        Ma carte de fidélité
      </div>

      {brouillon ? (
        <>
          <ApercuCarte nom={brouillon.nom} objectif={brouillon.objectif_tampons} recompense={brouillon.recompense}
            couleur={brouillon.couleur} logo={brouillon.logoApercu} banniere={brouillon.banniereApercu} />

          <label style={label}>Nom du commerce
            <input value={brouillon.nom} onChange={e => setBrouillon({ ...brouillon, nom: e.target.value })} style={champ} />
          </label>
          <label style={label}>Récompense (ex : Coupe offerte)
            <input value={brouillon.recompense} onChange={e => setBrouillon({ ...brouillon, recompense: e.target.value })} style={champ} />
          </label>
          <label style={label}>Tampons nécessaires
            <input type="number" min={3} max={30} value={brouillon.objectif_tampons}
              onChange={e => setBrouillon({ ...brouillon, objectif_tampons: e.target.value })} style={champ} />
          </label>

          <div style={label}>Couleur de la carte
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6, alignItems: 'center' }}>
              {COULEURS.map(c => (
                <button key={c} type="button" aria-label={`Couleur ${c}`} onClick={() => setBrouillon({ ...brouillon, couleur: c })}
                  style={{ width: 28, height: 28, borderRadius: '50%', background: c, cursor: 'pointer',
                    border: brouillon.couleur.toLowerCase() === c.toLowerCase() ? `3px solid ${CORAL}` : '2px solid #fff', boxShadow: '0 0 0 1px #e8e0d8' }} />
              ))}
              <input type="color" value={brouillon.couleur} aria-label="Autre couleur"
                onChange={e => setBrouillon({ ...brouillon, couleur: e.target.value })}
                style={{ width: 34, height: 30, border: 'none', background: 'none', cursor: 'pointer' }} />
            </div>
          </div>

          <label style={label}>Logo (carré de préférence)
            <input type="file" accept="image/png,image/jpeg" onChange={e => choisirImage(e, 'logo')} style={{ ...champ, padding: 6 }} />
          </label>
          <label style={label}>Photo de la boutique (bandeau, facultatif)
            <input type="file" accept="image/png,image/jpeg" onChange={e => choisirImage(e, 'banniere')} style={{ ...champ, padding: 6 }} />
          </label>
          {brouillon.banniereApercu && (
            <button type="button" onClick={() => setBrouillon({ ...brouillon, banniereFichier: null, banniereApercu: null })}
              style={{ background: 'none', border: 'none', color: '#888', fontSize: 12, cursor: 'pointer', padding: 0, marginBottom: 10 }}>
              Retirer la photo
            </button>
          )}

          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => setBrouillon(null)} disabled={enCours} style={{ flex: 1, background: '#f5f0eb', color: '#888', border: 'none', borderRadius: 8, padding: '10px', fontSize: 14, cursor: 'pointer' }}>Annuler</button>
            <button onClick={enregistrer} disabled={enCours} style={{ flex: 1, background: CHARBON, color: '#fff', border: 'none', borderRadius: 8, padding: '10px', fontSize: 14, fontWeight: 600, cursor: enCours ? 'wait' : 'pointer' }}>
              {enCours ? 'Enregistrement…' : 'Enregistrer'}
            </button>
          </div>
        </>
      ) : (
        <>
          <ApercuCarte nom={commerce?.nom} objectif={objectif} recompense={commerce?.recompense}
            couleur={commerce?.couleur || '#1C1C1C'} logo={commerce?.logo_url} banniere={commerce?.banniere_url} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {!demo && <>
            <a href="/affiche" style={{ background: CORAL, color: '#fff', borderRadius: 8, padding: '10px', fontSize: 14, fontWeight: 700, textDecoration: 'none', textAlign: 'center' }}>
              Imprimer mon affiche QR
            </a>
            <a href={`/c/${session.user.id}`} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#888', textAlign: 'center' }}>
              Voir la page d'inscription client ↗
            </a>
            </>}
            <button onClick={ouvrir} style={{ background: 'transparent', border: '1px solid #e8e0d8', borderRadius: 8, padding: '8px', fontSize: 13, color: '#666', cursor: 'pointer' }}>
              Personnaliser la carte
            </button>
          </div>
        </>
      )}
      {ok && <div style={{ fontSize: 13, color: '#3B6D11', marginTop: 8 }}>✅ Carte mise à jour</div>}
    </div>
  )
}
